import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormGroup,
  FormControlLabel,
  Switch,
  Box,
  Typography,
  Divider,
  IconButton
} from '@mui/material';
import { Settings as SettingsIcon } from '@mui/icons-material';
import { useSettings } from '../contexts/SettingsContext';

export const SettingsDialog = ({ open, onClose }) => {
  const { settings, toggleAI } = useSettings();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box display="flex" alignItems="center" gap={1}>
          <SettingsIcon />
          <span>Settings</span>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Typography variant="h6" gutterBottom>Appearance</Typography>
        <FormGroup>
          <FormControlLabel
            control={
              <Switch 
                checked={settings.enableAI}
                onChange={toggleAI}
                color="primary"
              />
            }
            label="Enable AI Assistant"
          />
          <Typography variant="caption" color="textSecondary" sx={{ mt: 1, display: 'block' }}>
            Toggle the AI Assistant feature on or off
          </Typography>
        </FormGroup>
        
        <Divider sx={{ my: 3 }} />
        
        <Typography variant="h6" gutterBottom>About</Typography>
        <Typography variant="body2" color="textSecondary">
          Trauma Network Tools v1.0.0
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export const SettingsButton = ({ onClick }) => {
  return (
    <IconButton 
      onClick={onClick}
      color="inherit"
      aria-label="settings"
      sx={{ 
        position: 'fixed',
        bottom: 16,
        right: 16,
        bgcolor: 'background.paper',
        boxShadow: 1,
        '&:hover': {
          bgcolor: 'action.hover',
        }
      }}
    >
      <SettingsIcon />
    </IconButton>
  );
};
